module.exports = __webpack_public_path__ + "static/media/icon-file-xml.885409e7.svg";